import styled from '../../../../../styles/theme';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledDS = styled(StockModelCardHeaderStyled)`
    .stockModelCard-header--engineInfo {
        font-size: ${rem(14)};
        color: ${({ theme }) => theme.colors.black};
    }

    .stockModelCard-header--heading {
        font-size: ${rem(32)};
    }
`;
